module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "fade"
    }
  }, _vm._l((_vm.records), function(record) {
    return _c('div', {
      key: record.id,
      staticClass: "record"
    }, [_c('record-item', {
      attrs: {
        "record": record,
        "read-only": _vm.readOnly,
        "selectedRecords": _vm.selectedRecords,
        "showSelectIndex": _vm.showSelectIndex,
        "isChoosingMode": _vm.isChoosingMode
      },
      on: {
        "delete-record-item": _vm.deleteRecord,
        "restore-record-item": _vm.restoreRecord,
        "edit-record-notes": _vm.editRecordNotes,
        "clicked-record-item": _vm.clickedRecordHandler,
        "mark-record-relevance-item": _vm.markRecord
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', [(_vm.recordPendingDeletion) ? _c('confirm-modal-2', {
    on: {
      "cancel": function($event) {
        _vm.recordPendingDeletion = null
      },
      "ok": _vm.confirmDeleteRecord
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('records.delete_confirmation')))])]), _vm._v(" "), _c('template', {
    slot: "ok"
  }, [_vm._v(_vm._s(_vm.$t('delete')))])], 2) : _vm._e(), _vm._v(" "), (_vm.recordNotesBeingEdited) ? _c('modal', {
    attrs: {
      "show": !!_vm.recordNotesBeingEdited,
      "okBtnText": _vm.$t('save'),
      "disableOkBtn": _vm.disableCommentModalBtn
    },
    on: {
      "ok": _vm.saveRecordComment,
      "hide": _vm.closeCommentModal
    }
  }, [_c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "edit-record-notes form-group"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordTitleEdited),
      expression: "recordTitleEdited"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-title",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.recordTitleEdited)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recordTitleEdited = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.recordHasDescriptionField) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordDescriptionEdited),
      expression: "recordDescriptionEdited"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-description",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.recordDescriptionEdited)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recordDescriptionEdited = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recordHasComment) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordCommentEdited),
      expression: "recordCommentEdited"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-description",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.recordCommentEdited)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recordCommentEdited = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recordNotesSaveInProgress),
      expression: "recordNotesSaveInProgress"
    }],
    staticClass: "loading-indicator"
  })])])], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-556adab1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/RecordsList.vue
// module id = 1044
// module chunks = 1